module.exports = __webpack_public_path__ + "static/img/dog-360-1.383f9ad9.png";